// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__m6swg","un":"FormInput_un__Jf4oD","invalid":"FormInput_invalid__P584m"};